var View = require('views/base/view');
var CollectionView = require('views/base/collection-view');

import CourseModuleView from 'developer/views/toolbar/course-module-view';
import SurveyView       from 'developer/views/toolbar/survey-view';
import AssessmentView   from 'developer/views/toolbar/assessment-view';
import ActionPlanView   from 'developer/views/toolbar/action-plan-view';

var CourseMapView = CollectionView.extend({
  template: require('./templates/course-map'),
  itemView: CourseModuleView,
  listSelector: '#accordion',
  autoRender: true,
  regions: {
    survey: '#survey_pane',
    assessment: '#assessment_pane',
    action_plan: '#action_plan_pane'
  },
  listen: {
    addedToDOM: 'loaded'
  },
  loaded: function(){
    if (EF.options.local) {
      var surveyView = new SurveyView({
        region: 'survey'
      });
      this.subview('survey', surveyView);

      var assessmentView = new AssessmentView({
        region: 'assessment'
      });
      this.subview('assessment', assessmentView);

      var actionPlanView = new ActionPlanView({
        region: 'action_plan'
      });
      this.subview('action_plan', actionPlanView);
    }
  },
  getTemplateData: function(){
    return {
      local: EF.options.local
    };
  }
});

module.exports = CourseMapView;